import styled from "styled-components";
import FontBase from "./FontBase";

const FontPSmallCenter = styled(FontBase)`
  font-size: ${p => p.theme.font.size.s};
  text-align:center;
`;

export default FontPSmallCenter;
